import axios, {AxiosError, AxiosRequestConfig} from 'axios';
import {BaseRequestHeader, IHandler, IHeadersManager} from '../types';

/**
 * Handler
 */
class Handler implements IHandler {
  readonly headersManager: IHeadersManager;

  onError: (error: AxiosError) => void;

  /**
   * Constructor
   * @param headersManager
   */
  constructor(headersManager: IHeadersManager) {
    this.headersManager = headersManager;
    this.onError = () => {};
  }

  /**
   * Get the headers for the request
   */
  public getHeaders(): BaseRequestHeader {
    return this.headersManager.getHeaders();
  }

  /**
   * Request handler
   * @param request
   */
  public async requestHandler<T>(request: AxiosRequestConfig): Promise<T> {
    try {
      const response = await axios(request);
      const data = response.data as T;
      return data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        this.onError(axiosError);
        throw axiosError;
      } else {
        throw error;
      }
    }
  }

  /**
   * Set the error handler
   * @param onError
   */
  public setErrorHandler(onError: (error: AxiosError) => void) {
    this.onError = onError;
  }
}

export default Handler;
